module.exports = __webpack_public_path__ + "img/service_tumb.01a86514.jpg";